import * as API from "../../utils/api";
import { makeApiCall } from "../../utils/customUtils";

export const FETCHING_DOCTOR_DATE_SPECIFIC_SCHEDULE = 'FETCHING_DOCTOR_DATE_SPECIFIC_SCHEDULE';
export const DOCTOR_DATE_SPECIFIC_SCHEDULE_FETCHED = 'DOCTOR_DATE_SPECIFIC_SCHEDULE_FETCHED';
export const FAILED_TO_FETCH_DOCTOR_DATE_SPECIFIC_SCHEDULE = 'FAILED_TO_FETCH_DOCTOR_DATE_SPECIFIC_SCHEDULE';
export const DOCTOR_DATE_SPECIFIC_SCHEDULE_SAVED = 'DOCTOR_DATE_SPECIFIC_SCHEDULE_SAVED';
export const FAILED_TO_SAVE_DOCTOR_DATE_SPECIFIC_SCHEDULE = 'FAILED_TO_SAVE_DOCTOR_DATE_SPECIFIC_SCHEDULE';
export const REMOVE_DOCTOR_SCHEDULE_GROUP_SAVED = 'REMOVE_DOCTOR_SCHEDULE_GROUP_SAVED';
export const FAILED_TO_REMOVE_DOCTOR_SCHEDULE_GROUP = 'FAILED_TO_REMOVE_DOCTOR_SCHEDULE_GROUP';
export const REMOVE_DOCTOR_SCHEDULE_SLOT_SAVED = 'REMOVE_DOCTOR_SCHEDULE_SLOT_SAVED';
export const FAILED_TO_REMOVE_DOCTOR_SCHEDULE_SLOT = 'FAILED_TO_REMOVE_DOCTOR_SCHEDULE_SLOT';
//calender integration
export const DOCTOR_INTEGRATED_CALENDAR_DISCONNECTED =	'DOCTOR_INTEGRATED_CALENDAR_DISCONNECTED';
export const FAILED_TO_DISCONNECT_DOCTOR_INTEGRATED_CALENDAR =	'FAILED_TO_DISCONNECT_DOCTOR_INTEGRATED_CALENDAR';

export function GetDoctorDateSpecificSchedule() {
  return async (dispatch) => {
    dispatch({ type: FETCHING_DOCTOR_DATE_SPECIFIC_SCHEDULE });
    const url = `Visit/get-doctor-schedule-availability`;
    const api = API.get(
      url,
      {},
      dispatch,
      undefined,
      true,
      false,
    );
    return await makeApiCall(
      dispatch,
      api,
      DOCTOR_DATE_SPECIFIC_SCHEDULE_FETCHED,
      FAILED_TO_FETCH_DOCTOR_DATE_SPECIFIC_SCHEDULE,
    );
  };
}

export function SaveDoctorDateSpecificSchedule(payload = {}) {
	return async (dispatch) => {
		const url = `Visit/save-doctor-schedule-availability`;
		const api = API.post(
			url,
			{ data: payload },
			dispatch,
			undefined,
			true,
			false,
		);
		return await makeApiCall(
			dispatch,
			api,
			DOCTOR_DATE_SPECIFIC_SCHEDULE_SAVED,
			FAILED_TO_SAVE_DOCTOR_DATE_SPECIFIC_SCHEDULE,
			'post',
		);
	};
}

export function RemoveDoctorScheduleGroup(groupGuid, updatedBy) {
  return async (dispatch) => {
    const data = {
      groupGuid,
      updatedBy,
    };
    const url = `Visit/remove-doctor-schedule-group/${groupGuid}/${updatedBy}`;
    const api = API.post(
      url,
      { data },
      dispatch,
      undefined,
      true,
      false,
    );

    return await makeApiCall(
      dispatch,
      api,
      REMOVE_DOCTOR_SCHEDULE_GROUP_SAVED,
      FAILED_TO_REMOVE_DOCTOR_SCHEDULE_GROUP,
      'post',
    );
  };
}
//check if needed
export function RemoveDoctorScheduleSlot(id, updatedBy) {
  return async (dispatch) => {
    const data = {
      id,
      updatedBy,
    };
    const url = `Visit/remove-doctor-schedule-slot/${id}/${updatedBy}`;
    const api = API.post(
      url,
      { data },
      dispatch,
      undefined,
      true,
      false,
    );
    return await makeApiCall(
      dispatch,
      api,
      REMOVE_DOCTOR_SCHEDULE_SLOT_SAVED,
      FAILED_TO_REMOVE_DOCTOR_SCHEDULE_SLOT,
      'post',
    );
  };
}
export function DisconnectDoctorIntegratedCalendar(url) {
	return async dispatch => {
		const api = API.post(
			url,
			{},
			dispatch,
			undefined,
			true,
			true,
		);
		return await makeApiCall(
			dispatch,
			api,
			DOCTOR_INTEGRATED_CALENDAR_DISCONNECTED,
			FAILED_TO_DISCONNECT_DOCTOR_INTEGRATED_CALENDAR,
			'post',
		);
	};
}
